<template>
    <div class="height-percent-100">
        <div class="filter uk-flex uk-flex-center uk-flex-middle" style="border-bottom:1px solid #ccc">
            <el-input type="text" style="width:250px" :placeholder="$t('public.please_enter')" v-model="filterText" clearable></el-input>
            <el-button type="primary" icon="el-icon-search" class="btnClass" @click="searchTree"></el-button>
        </div>

        <div class="schema-tree">
            <trees ref="tree" :treedata="treeData" :defaultChecked="defaultChecked" @changeNode="changeNode"></trees>
        </div>
    </div>
</template>

<script>
import { shareTree } from '@/api/modules/public'

export default {
  computed: {
    treeProp () {
      return {
        children: 'item'
      }
    }
  },
  data () {
    return {
      filterText: '',
      treeData: [],
      defaultChecked: null
    }
  },
  watch: {
    treeData (newVal) {
      if (newVal.length > 0 && !this.defaultChecked) {
        this.defaultChecked = newVal[0].scene_code
      }
    }
  },
  methods: {
    loadTreeData () {
      shareTree({
        isEdit: 0,
        carrier: true,
        sensor: true,
        all: true
      }).then(({ result }) => {
        const tree = (result && result.item) || []
        this.treeData = tree.filter(node => node.sceneCode !== 'all_node')
      })
    },
    searchTree () {
      this.$refs.tree.$refs.tree.filter(this.filterText)
    },
    changeNode (e) {
      this.$emit('changeNode', e.label)
    },
    // 外部调用此方法选中指定节点
    selectNodeById (type, nodeId) {
      if (this.$refs.tree && this.$refs.tree.$refs.tree) {
        const treeRef = this.$refs.tree.$refs.tree;
        // 使用 store.nodesMap 获取所有节点数据
        const nodesMap = treeRef.store.nodesMap;
        let targetKey = '';
        let parentKey = '';

        // 遍历所有节点，根据 type 和 nodeId 找到对应的节点 key
        for (const key in nodesMap) {
          const nodeData = nodesMap[key].data;
          // type 0: scope/客户范围, 1: scene/组织架构, 2: carrier/资产
          if (type === 0) {
            // 客户范围：精确匹配 scope_id，且为根节点（level === 0 或无 parent）
            if (nodeData.scope_id === nodeId) {
              const parentNode = nodesMap[key].parent;
              // 根节点判断：没有父节点或父节点是虚拟根节点
              const isRootNode = !parentNode || parentNode.level < 0;
              if (isRootNode || nodeData.level === 0 || nodeData.funcType === 0) {
                targetKey = key;
                break;
              }
            }
          } else if (type === 1) {
            // 场景：匹配 scene_id、id 或 scene_code
            if (nodeData.scene_id === nodeId || nodeData.id === nodeId || key === nodeId) {
              targetKey = key;
              break;
            }
          } else if (type === 2) {
            // 资产：匹配 carrier_id、id 或 scene_code
            if (nodeData.carrier_id === nodeId) {
              targetKey = key;
              // 找到父节点的 key 用于展开
              const parentNode = nodesMap[key].parent;
              if (parentNode) {
                parentKey = parentNode.key;
              }
              break;
            }
          }
        }

        if (targetKey) {
          treeRef.setCurrentKey('');
          treeRef.setCurrentKey(targetKey);
          this.$refs.tree.defaultExpandedkeys = [];
          this.$refs.tree.defaultExpandedkeys = [targetKey];
        }
      }
    }
  },
  mounted () {
    this.loadTreeData()
  }
}
</script>

<style scoped>
.height-percent-100 {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.schema-tree {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
}

.filter {
    padding: 10px 5px;
    flex-shrink: 0;
}
</style>
